import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { IntegrationsComponent } from '../../integrations.component';
import { RMO_Property, RMO_PropertyMapping } from '../../models/rentManager';
import { IntegrationsService } from '../../services/integrations.service';
import { ClientLocation } from 'src/app/clients-module/models/clientLocation';

@Component({
  selector: 'app-rentman-property-mapping-modal',
  templateUrl: './rentman-property-mapping-modal.component.html',
  styleUrls: ['./rentman-property-mapping-modal.component.less']
})
export class RentmanPropertyMappingModalComponent implements OnInit, OnDestroy {

  @Input() corpId: string;
  @Input() riqClientId: number;

  rmoProperties: RMO_Property[] = [];
  rmoPropertyMappings: RMO_PropertyMapping[] = [];

  locationsLoaded: boolean = false;
  mappingsLoaded: boolean = false;

  validationErrors: object = {};

  $propSub: Subscription;
  $propLoadedSub: Subscription;
  $mappingsSub: Subscription;

  constructor(public modalService: NgbModal, public locations: PropertyService, public integrations: IntegrationsService, public toastr: ToastrService) { }
  ngOnDestroy(): void {
    this.$propLoadedSub.unsubscribe();
    this.$propSub.unsubscribe();
    this.$mappingsSub.unsubscribe();
    this.locations.properties = [];
  }

  ngOnInit() {
    this.locations.FetchPropertiesForClient(this.riqClientId);
    this.$propLoadedSub = this.locations.propertiesLoaded.subscribe(res => {
      this.locationsLoaded = true;
      _.forEach(this.locations.properties, prop => { 
        this.validationErrors[prop.id] = false;
        prop.hasExistingPMSMapping = false;
        prop.rmoPropertyAssignmentId = 0;
       });
      //fetch the RMO properties after we have the RIQ locations in hand
      this.$propSub = this.integrations.GetRMOPropertiesForClient(this.riqClientId).subscribe((res: RMO_Property[]) => {
        let emptyValue = new RMO_Property();
        emptyValue.propertyID = 0;
        emptyValue.name = "None";
        this.rmoProperties.push(emptyValue);
        this.rmoProperties.push(...res);
        // console.log('RMO PROPERTIEs', this.rmoProperties);
        //last, fetch the existing mappings
        this.$mappingsSub = this.integrations.GetRMOLocationMappings(this.riqClientId).subscribe((res: RMO_PropertyMapping[]) => {
          this.rmoPropertyMappings = res;
          this.populateMappings();
        },
        err => { this.toastr.error('Error fetching RMO Property mappings!', '', { disableTimeOut: true, closeButton: true }) },
        () => {}) 
      },
      err => { this.toastr.error('Error fetching RMO Properties!', '', { closeButton: true, disableTimeOut: true }) },
      () => {})
    },
    err => { this.locationsLoaded = false; this.toastr.error('ClientLocations failed to load!', '', { closeButton: true, disableTimeOut: true }) });

  }

  populateMappings(): void {
    _.forEach(this.rmoPropertyMappings, mapping => {
      let riqloc = _.find(this.locations.properties, prop => { return prop.id === mapping.clientLocationId });
      if(riqloc){
        riqloc.rmoPropertyAssignmentId = mapping.rmO_PropertyId;
        riqloc.rmoLocationId = mapping.rmO_LocationId;
        riqloc.propertyMapping = this.rmoProperties.find(pr => {return pr.propertyID == mapping.rmO_PropertyId && pr.locationId == mapping.rmO_LocationId;});
        //NOTE TO SELF: LOCK DROPDOWNS IF A MAPPING ALREADY EXISTS!
        riqloc.hasExistingPMSMapping = true;
        console.log('setting up mapping', riqloc);
      }
    });
    this.mappingsLoaded = true;
    
  }

  propertySelected(prop : ClientLocation, loc : RMO_Property)
  {
    if(prop.rmoPropertyAssignmentId == loc.propertyID && prop.rmoLocationId == loc.locationId)
    {
      if(prop.id == 8927) console.log('found match', prop,loc);
      return true;
    }
    return false;
  }

  save(): void {
    if(this.validate()) {
      let locMappings = this.buildPropertyMappingList();
      this.integrations.SaveRMOPropertyMappings(locMappings).subscribe(res => {
        this.toastr.success('Property mappings saved!', '');
        this.modalService.dismissAll();
      },
      err => { this.toastr.error('Error saving property mappings!', '', { disableTimeOut: true, closeButton: true }) },
      () => {  });
    }
    else {
      this.toastr.error('One or more validation errors exist.', '');
    }

  }

  validate(): boolean {
    let passedValidation: boolean = true;

    //the primary validation rule is that a RMO location cannot be assigned to more than one RIQ client
    //check all the properties and make sure we don't have more than one assigned rmoPropertyAssignment
    _.forEach(this.locations.properties, map => {
      this.validationErrors[map.id] = false;
      //if a rmo propId is NOT assigned, or the prop has an existing mapping, don't evaluate.
      if(map.rmoPropertyAssignmentId === undefined || map.rmoPropertyAssignmentId < 1 || map.hasExistingPMSMapping === true) return;
      let count = _.filter(this.locations.properties, m => {   
        return m.rmoPropertyAssignmentId == map.rmoPropertyAssignmentId
      });
      if(count.length > 1 && map.rmoPropertyAssignmentId > 0) {
        this.validationErrors[map.id] = true;
        passedValidation = false;
      }
    });

    return passedValidation;
  }

  buildPropertyMappingList(): RMO_PropertyMapping[] {
    let locMappings: RMO_PropertyMapping[] = [];
    _.forEach(this.locations.properties, prop => {
      if(prop.hasExistingPMSMapping) return;
      if(!prop.propertyMapping) return;
      let newmap = new RMO_PropertyMapping();
      newmap.corpId = this.corpId;
      newmap.clientLocationId = prop.id;
      newmap.rmO_PropertyId = prop.propertyMapping.propertyID;
      newmap.rmO_LocationId = prop.propertyMapping.locationId;
      if(newmap.rmO_PropertyId > 0) locMappings.push(newmap); 
    });

    return locMappings;
  }

  syncPropertyList(): void {
    _.forEach(this.locations.properties, prop => {
      if(prop.hasExistingPMSMapping) return;
      let existing = _.find(this.rmoProperties, rmo => { return rmo.name.toLowerCase() === prop.locationName.toLowerCase() })
      if(existing) {
        prop.rmoPropertyAssignmentId = existing.propertyID;
      };
    })
  }
}
